import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";

// Lazy load non-critical pages for better performance
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const ConciergeriePage = lazy(() => import("@/pages/ConciergeriePage"));
const SousLocationPage = lazy(() => import("@/pages/SousLocationPage"));
const GrandeMottePage = lazy(() => import("@/pages/GrandeMottePage"));
const GrauDuRoiPage = lazy(() => import("@/pages/GrauDuRoiPage"));
const AiguesMortesPage = lazy(() => import("@/pages/AiguesMortesPage"));
const CarnonPage = lazy(() => import("@/pages/CarnonPage"));
const FAQPage = lazy(() => import("@/pages/FAQPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const BlogPage = lazy(() => import("@/pages/BlogPage"));
const BlogPostPage = lazy(() => import("@/pages/BlogPostPage"));
const DevisPage = lazy(() => import("@/pages/DevisPage"));
const NosLocationsPage = lazy(() => import("@/pages/NosLocationsPage"));
const ReservationPage = lazy(() => import("@/pages/ReservationPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const MentionsLegalesPage = lazy(() => import("@/pages/MentionsLegalesPage"));
const CGUPage = lazy(() => import("@/pages/CGUPage"));
const PolitiqueConfidentialitePage = lazy(() => import("@/pages/PolitiqueConfidentialitePage"));
const RenseignerBienPage = lazy(() => import("@/pages/RenseignerBienPage"));
const EtatDesLieuxPage = lazy(() => import("@/pages/EtatDesLieuxPage"));
const ChecklistMenagePage = lazy(() => import("@/pages/ChecklistMenagePage"));
const RapportMensuelPage = lazy(() => import("@/pages/RapportMensuelPage"));
const LivretAccueilPage = lazy(() => import("@/pages/LivretAccueilPage"));
const TarificationPage = lazy(() => import("@/pages/TarificationPage"));
const FicheInterventionPage = lazy(() => import("@/pages/FicheInterventionPage"));
const SatisfactionVoyageurPage = lazy(() => import("@/pages/SatisfactionVoyageurPage"));
const SousLocationFormPage = lazy(() => import("@/pages/SousLocationFormPage"));
const TarifsPage = lazy(() => import("@/pages/TarifsPage"));

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-[#d4af37] border-t-transparent rounded-full animate-spin" /></div>}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/a-propos" element={<AboutPage />} />
              <Route path="/conciergerie" element={<ConciergeriePage />} />
              <Route path="/sous-location-conciergerie" element={<SousLocationPage />} />
              <Route path="/conciergerie-la-grande-motte" element={<GrandeMottePage />} />
              <Route path="/conciergerie-grau-du-roi" element={<GrauDuRoiPage />} />
              <Route path="/conciergerie-aigues-mortes" element={<AiguesMortesPage />} />
              <Route path="/conciergerie-carnon" element={<CarnonPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/nos-actualites" element={<BlogPage />} />
              <Route path="/nos-actualites/:slug" element={<BlogPostPage />} />
              <Route path="/devis" element={<DevisPage />} />
              <Route path="/tarifs" element={<TarifsPage />} />
              <Route path="/nos-locations" element={<NosLocationsPage />} />
              <Route path="/reservation" element={<ReservationPage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/conditions-generales" element={<CGUPage />} />
              <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialitePage />} />
            </Route>
            <Route path="/fiche-de-renseignements" element={<RenseignerBienPage />} />
            <Route path="/etat-des-lieux" element={<EtatDesLieuxPage />} />
            <Route path="/checklist-menage" element={<ChecklistMenagePage />} />
            <Route path="/rapport-mensuel" element={<RapportMensuelPage />} />
            <Route path="/livret-accueil" element={<LivretAccueilPage />} />
            <Route path="/tarification" element={<TarificationPage />} />
            <Route path="/fiche-intervention" element={<FicheInterventionPage />} />
            <Route path="/satisfaction-voyageur" element={<SatisfactionVoyageurPage />} />
            <Route path="/demande-sous-location" element={<SousLocationFormPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
